
export const RoleListMobile = [
    {
        id: undefined,
        module: "account",
        moduleName: "Tài khoản",
        title: "Cho phép tài khoản mới có quyền quản lý danh sách các tài khoản đã tạo",
        roleView: false,
        roleCreate: false
    },
    {
        id: undefined,
        module: "weighingStation",
        moduleName: "Trạm cân",
        title: "Cho phép tài khoản mới có quyền quản lý danh sách các trạm cân",
        roleView: true,
        roleCreate: false
    },
]
